import {
  ErrorResponse,
  GlobalResponseObject,
  GlobalVariableValues,
  LeaveApprovalStatusEnum,
  MessageParameters,
} from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { RequestDto } from './dto/request.dto';
import { RequestForm } from './entity/request.entity';
import { RequestRepo } from './repository/request.repo';
import { RequestFormAdapter } from './request.adapter';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { Between, getManager, LessThan, MoreThan } from "typeorm";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import { RequestById } from "./dto/request.request";
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { BroadCastMessageRequest, WhatsAppBroadCastRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { RequestReport } from "./dto/request.report";
import moment from "moment";
import { VisitorAdapter } from "./security.adapter";
import { VisitorRepo } from "./repository/security.repo";
import { VisitorDto } from "./dto/security.dto";
import { VisitorEntry } from "./entity/security.entity";
import { whatsApp } from '../../../../whatsapp';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { RequestByName } from './dto/request.name';


@Injectable()
export class RequestService {

    constructor(
        private adapter: RequestFormAdapter,
        private requestRepo: RequestRepo,
        private wtsAppBroadCatService: WhatsAppNotificationService,
        private visitorAdapter: VisitorAdapter,
        private visitorRepo: VisitorRepo,
        private brodcasrservice: WhatsappBroadCastService

    ) { }

    async createRequest(createDto: RequestDto): Promise<CommonResponse> {
        // const visitorCode = `Visit${new Date().getFullYear()}`
        const requestEntity = this.adapter.convertDtoToEntity(createDto);
        // requestEntity.visitorCode = visitorCode;
        const requestSave = await this.requestRepo.save(requestEntity);
        if (requestSave) {
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": requestSave.requestId > 0 ? String(requestSave.requestId) : "No Data" },
                { "type": "text", "text": requestSave.visitorName  ? requestSave.visitorName : "No Data" },
                { "type": "text", "text": requestSave.visitorMobileNumber  ? requestSave.visitorMobileNumber : "No Data" },
                { "type": "text", "text": moment(requestSave.visitorArrivalDate).format('YYYY-MM-DD HH:mm:ss')  ? moment(requestSave.visitorArrivalDate).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                { "type": "text", "text": moment(requestSave.visitorDepartureDate).format('YYYY-MM-DD HH:mm:ss')  ? moment(requestSave.visitorDepartureDate).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                { "type": "text", "text": requestSave.purposeOfVisit  ? requestSave.purposeOfVisit : "No Data" },
                { "type": "text", "text": requestSave.whomMeet  ? requestSave.whomMeet : "No Data" },
                { "type": "text", "text": moment(requestSave.createdAt).format('YYYY-MM-DD HH:mm:ss')  ? moment(requestSave.createdAt).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                { "type": "text", "text": 'Applied' },
            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'visitor_hod_message', parameters, "en_us")
                const messageStatus = await this.wtsAppBroadCatService.sendMessageThroughFbApi(req);
                console.log(messageStatus , '***')
                if(!messageStatus.status){
                    statusFlag = false
                  }else{
                    const manager = getManager();
                    statusFlag = true
                    const whatsapplogDto = new WhatsAppLogDto(contact,'visitor_hod_message','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.vistorManagementId)
         await this.brodcasrservice.createWhatappLog(whatsapplogDto)
                    // const testdata = 'INSERT INTO '+appSettings.whatsapp_db+'.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("'+contact+'","visitor_hod_message","Schemax",'+GlobalVariableValues.companyId+','+GlobalVariableValues.vistorManagementId+')'
                    //  const result =await manager.query(testdata)
                    // const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                  }
            }
        }
        if(requestSave) {
          const parameters = [
            { "type": "text", "text": requestSave.requestId > 0 ? String(requestSave.requestId) : "No Data" },
            { "type": "text", "text": requestSave.visitorName  ? requestSave.visitorName.toString() : "No Data" },
            { "type": "text", "text": moment(requestSave.createdAt).format('YYYY-MM-DD HH:mm:ss')  ? moment(requestSave.createdAt).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
            { "type": "text", "text": `http://hrms.schemaxtech.in/#/visitor-statusreport/${requestSave.requestId}` }
            
          ];
          const contacts = [requestSave.visitorMobileNumber]
            for (const contact of contacts) {
                let flag = true
                const req = new MessageParameters(contact, 'visitor_request_message', parameters, "en_us")
                const messageStatus = await this.wtsAppBroadCatService.sendMessageThroughFbApi(req);
                console.log(messageStatus , '***')
                if(!messageStatus.status){
                    flag = false
                  }else{
                    const manager = getManager();
                    flag = true
                    const whatsapplogDto = new WhatsAppLogDto(contact,'visitor_request_message','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.vistorManagementId)
                    await this.brodcasrservice.createWhatappLog(whatsapplogDto)
                  }
            }
        }
        return new CommonResponse(true, 98898, "Successfully Created", requestSave);
    }


  async getAllRequests(): Promise<CommonResponse> {
    const getrequestDto: RequestDto[] = [];
    const getrequestEntities: RequestForm[] = await this.requestRepo.find({
      where: {
        visitorDepartureDate: MoreThan(moment(new Date()).format('YYYY-MM-DD')),
      },
    });
    if (getrequestEntities.length) {
      for (const getrequestEntity of getrequestEntities) {
        const convertedRequestDto: RequestDto = this.adapter.convertEntityToDto(
          getrequestEntity
        );
        getrequestDto.push(convertedRequestDto);
      }
      const response = new CommonResponse(
        true,
        1,
        'Requests retrieved successfully',
        getrequestDto
      );
      return response;
    } else {
      throw new CommonResponse(false, 99998, 'Data not found');
    }
  }

    async updateStatusHod(updateHodReq: RequestDto): Promise<GlobalResponseObject> {
        console.log(updateHodReq, "********************")
        const transManager = new GenericTransactionManager();
        const requestHod = await this.requestRepo.findOne({ where: { requestId: updateHodReq.requestId } })
        if (requestHod) {
            await transManager.startTransaction();
            if (updateHodReq.statusByHod == LeaveApprovalStatusEnum.APPROVED) {
                const hodStatusUpdate = await transManager.getCustomRepository(RequestRepo).update({ requestId: updateHodReq.requestId }, { visitorName: updateHodReq.visitorName.toString(), visitorEmail: updateHodReq.visitorEmail, visitorMobileNumber: updateHodReq.visitorMobileNumber, visitorAddress: updateHodReq.visitorAddress, visitorArrivalDate: updateHodReq.visitorArrivalDate, visitorDepartureDate: updateHodReq.visitorDepartureDate, purposeOfVisit: updateHodReq.purposeOfVisit, whomMeet: updateHodReq.whomMeet });
                if (hodStatusUpdate.affected) {
                    const hodStatusAdjUpdate = await transManager.getCustomRepository(RequestRepo).update({ requestId: requestHod.requestId }, { statusByHod: LeaveApprovalStatusEnum.APPROVED })
                    if (hodStatusAdjUpdate.affected) {
                        await transManager.completeTransaction();
                        const parameters = [
                            { "type": "text", "text": moment().format('DD-MM-YYYY') },
                            { "type": "text", "text": updateHodReq.requestId > 0 ? String(updateHodReq.requestId) : "No Data" },
                            { "type": "text", "text": updateHodReq.visitorName  ? updateHodReq.visitorName.toString() : "No Data" },
                            { "type": "text", "text": updateHodReq.visitorMobileNumber  ? updateHodReq.visitorMobileNumber : "No Data" },
                            { "type": "text", "text": moment(updateHodReq.visitorArrivalDate).format('YYYY-MM-DD HH:mm:ss')  ? moment(updateHodReq.visitorArrivalDate).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                            { "type": "text", "text": moment(updateHodReq.visitorDepartureDate).format('YYYY-MM-DD HH:mm:ss')  ? moment(updateHodReq.visitorDepartureDate).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                            { "type": "text", "text": updateHodReq.purposeOfVisit  ? updateHodReq.purposeOfVisit : "No Data" },
                            { "type": "text", "text": updateHodReq.whomMeet  ? updateHodReq.whomMeet : "No Data" },
                            { "type": "text", "text": updateHodReq.statusByHod ? updateHodReq.statusByHod : "No Data"}
                        ];
                        for (const contact of whatsApp.contacts) {
                            let statusFlag = true
                            const req = await new MessageParameters(contact, 'visitor_hr_message', parameters, "en_us")
                            const messageStatus = await this.wtsAppBroadCatService.sendMessageThroughFbApi(req);
                            console.log(messageStatus , '***')
                            if(!messageStatus.status){
                                statusFlag = false
                              }else{
                                const manager = getManager();
                                statusFlag = true
                                const whatsapplogDto = new WhatsAppLogDto(contact,'visitor_hr_message','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.vistorManagementId)
                    await this.brodcasrservice.createWhatappLog(whatsapplogDto)
                               
                              }
                        }
                        return new GlobalResponseObject(true, 111101, 'Hod status approved and updated successfully');
                    } else {
                        await transManager.releaseTransaction();
                        return new GlobalResponseObject(false, 11101, 'Something went wrong in Hod status updation')
                    }
                } else {
                    await transManager.releaseTransaction();
                    return new GlobalResponseObject(false, 11101, 'Something went wrong in Hod status updation')
                }
            } else if (updateHodReq.statusByHod == LeaveApprovalStatusEnum.REJECTED) {
                const hodRejUpdate = await transManager.getCustomRepository(RequestRepo).update({ requestId: updateHodReq.requestId }, { statusByHod: LeaveApprovalStatusEnum.REJECTED, rejectionReason: updateHodReq.rejectionReason })
                if (hodRejUpdate.affected) {
                    await transManager.completeTransaction();
                    return new GlobalResponseObject(true, 11101, 'Hod status Rejected successfully');
                } else {
                    await transManager.releaseTransaction();
                    return new GlobalResponseObject(false, 11101, 'Something went wrong in rejection by Hod')
                }
            }
        }else {
                 return new GlobalResponseObject(false, 11106, 'RequestId not found');
                 }
      }


  async getHodApprovedRequests(req: RequestReport): Promise<CommonResponse> {
    console.log(req,"request");
    console.log('-----------------------------');
    console.log(req.fromDate);
    
    console.log('-----------------------------');
    const getapprovedDto: RequestDto[] = [];
    let getapprovedEntities: RequestForm[] =[];
    getapprovedEntities = await this.requestRepo.find({ where: { statusByHod: 'APPROVED',visitorDepartureDate: MoreThan(moment(new Date()).format('YYYY-MM-DD')), }});
    if(req.fromDate !== null) {
      getapprovedEntities = await this.requestRepo.find({where: {statusByHod: 'APPROVED',visitorArrivalDate: Between(req.fromDate, req.toDate), visitorDepartureDate: Between(req.fromDate,req.toDate)}})
     } 

  console.log(getapprovedEntities,"e")
    if (getapprovedEntities.length) {
      for (const getapprovedEntity of getapprovedEntities) {
        const convertedApprovedRequestDto: RequestDto = this.adapter.convertEntityToDto(
          getapprovedEntity
        );
        getapprovedDto.push(convertedApprovedRequestDto);
      }
      const response = new CommonResponse(
        true,
        1,
        'Approved Requests retrieved successfully',
        getapprovedDto
      );
      return response;
    } else {
      throw new CommonResponse(false, 99998, 'No one is approved');
    }
  }

  async updateStatusHr(updateHrReq: RequestDto): Promise<GlobalResponseObject> {
    const transManager = new GenericTransactionManager();
    const requestHr = await this.requestRepo.findOne({
      where: { requestId: updateHrReq.requestId },
    });
    if (requestHr) {
      await transManager.startTransaction();
      if (updateHrReq.statusByHr == LeaveApprovalStatusEnum.APPROVED) {
        const hrStatusUpdate = await transManager
          .getCustomRepository(RequestRepo)
          .update(
            { requestId: updateHrReq.requestId },
            {
              visitorName: updateHrReq.visitorName.toString(),
              visitorEmail: updateHrReq.visitorEmail,
              visitorMobileNumber: updateHrReq.visitorMobileNumber,
              visitorAddress: updateHrReq.visitorAddress,
              visitorArrivalDate: updateHrReq.visitorArrivalDate,
              visitorDepartureDate: updateHrReq.visitorDepartureDate,
              purposeOfVisit: updateHrReq.purposeOfVisit,
              whomMeet: updateHrReq.whomMeet,
            }
          );
        if (hrStatusUpdate.affected) {
          const hrStatusAdjUpdate = await transManager
            .getCustomRepository(RequestRepo)
            .update(
              { requestId: requestHr.requestId },
              { statusByHr: LeaveApprovalStatusEnum.APPROVED }
            );
          // const mes = " \n " + 'RequestId:' + updateHrReq.requestId + " \n " + 'Visitor Name:' + updateHrReq.visitorName + " \n " + 'Arrival Date :' + updateHrReq.visitorArrivalDate + "\n" + 'Departure Date:' + updateHrReq.visitorDepartureDate + "\n"
          // const msgReq = new BroadCastMessageRequest(31, mes, [whatsApp.UsageReport])
          // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(msgReq);
          if (hrStatusAdjUpdate.affected) {
            await transManager.completeTransaction();
            const parameters = [
                { "type": "text", "text": updateHrReq.visitorName  ? updateHrReq.visitorName.toString() : "No Data" },
                { "type": "text", "text": updateHrReq.whomMeet  ? updateHrReq.whomMeet : "No Data" },
                { "type": "text", "text": moment(updateHrReq.visitorArrivalDate).format('YYYY-MM-DD HH:mm:ss')  ? moment(updateHrReq.visitorArrivalDate).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                            { "type": "text", "text": moment(updateHrReq.visitorDepartureDate).format('YYYY-MM-DD HH:mm:ss')  ? moment(updateHrReq.visitorDepartureDate).format('YYYY-MM-DD HH:mm:ss') : "No Data" },
                { "type": "text", "text": updateHrReq.requestId > 0 ? String(updateHrReq.requestId) : "No Data" },
                { "type": "text", "text": `http://hrms.schemaxtech.in/#/visitor-card/${updateHrReq.requestId}` }

            ];
            const contacts = [...whatsApp.contacts ,updateHrReq.visitorMobileNumber ]
            for (const contact of contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'visitor_pass_message', parameters, "en_us")
                const messageStatus = await this.wtsAppBroadCatService.sendMessageThroughFbApi(req);
                console.log(messageStatus , '***')
                if(!messageStatus.status){
                    statusFlag = false
                  }else{
                    statusFlag = true
                    const whatsapplogDto = new WhatsAppLogDto(contact,'visitor_pass_message','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.vistorManagementId)
                    await this.brodcasrservice.createWhatappLog(whatsapplogDto)
                  }
            }
            return new GlobalResponseObject(
              true,
              111101,
              'Hr status approved and updated successfully'
            );
          } else {
            await transManager.releaseTransaction();
            return new GlobalResponseObject(
              false,
              11101,
              'Something went wrong in Hr status updation'
            );
          }
        } else {
          await transManager.releaseTransaction();
          return new GlobalResponseObject(
            false,
            11101,
            'Something went wrong in Hr status updation'
          );
        }
      } else if (updateHrReq.statusByHr == LeaveApprovalStatusEnum.REJECTED) {
        const hrRejUpdate = await transManager
          .getCustomRepository(RequestRepo)
          .update(
            { requestId: updateHrReq.requestId },
            {
              statusByHr: LeaveApprovalStatusEnum.REJECTED,
              rejectionReason: updateHrReq.rejectionReason,
            }
          );
        if (hrRejUpdate.affected) {
          await transManager.completeTransaction();
          return new GlobalResponseObject(
            true,
            11101,
            'Hr status Rejected successfully'
          );
        } else {
          await transManager.releaseTransaction();
          return new GlobalResponseObject(
            false,
            11101,
            'Something went wrong in rejection by Hr'
          );
        }
      }
    } else {
      return new GlobalResponseObject(false, 11106, 'RequestId not found');
    }
  }

  async getRequestById(): Promise<CommonResponse> {
    const getReqIdDto: RequestDto[] = [];
    // const responseEntities: RequestForm[] = await this.requestRepo.checkInData();
    const responseEntities: RequestForm[] = await this.requestRepo.find({
      where: {
        statusByHod: 'APPROVED',
        statusByHr: 'APPROVED',
        visitorDepartureDate: MoreThan(new Date()),
      },
    });
    if (responseEntities.length) {
      for (const responseEntity of responseEntities) {
        const convertedReqIdDto: RequestDto = this.adapter.convertEntityToDto(
          responseEntity
        );
        const getCheckEntities: VisitorEntry[] = await this.visitorRepo.find({
          order: { id: 'ASC' },
          where: { requestId: responseEntity.requestId },
        });
        convertedReqIdDto['visitorStatus'] = [];
        for (const visitor of getCheckEntities) {
          convertedReqIdDto['visitorStatus'].push({
            checkIn: visitor.checkIn,
            checkOut: visitor.checkOut,
            name: visitor.visitorName,
            visitorCard:visitor.visitorCard
          });
        }
        getReqIdDto.push(convertedReqIdDto);
      }
      return new CommonResponse(
        true,
        1,
        'Request retrieved succesfully',
        getReqIdDto
      );
    } else {
      return new CommonResponse(false, 11101, 'No one are approved');
    }
  }

  async getById(req: RequestById): Promise<CommonResponse> {
    const getReqIdDto: RequestDto[] = [];
    const responseEntity = await this.requestRepo.findOne({
      where: {
        requestId: req.requestId,
        statusByHod: 'APPROVED',
        statusByHr: 'APPROVED',
      },
    });
    if (responseEntity) {
      const convertedReqIdDto: RequestDto = this.adapter.convertEntityToDto(
        responseEntity
      );
      getReqIdDto.push(convertedReqIdDto);
      return new CommonResponse(
        true,
        1,
        'Request retrieved successfully',
        getReqIdDto
      );
    } else {
      return new CommonResponse(false, 11101, 'RequestId not found');
    }
  }

  async getRequestByName(req: RequestDto): Promise<CommonResponse> {
    const getReqByName: RequestDto[] = [];
    const responseEntities: RequestForm[] = await this.requestRepo.find({
      where: {
        visitorName: req.visitorName,
        statusByHod: 'APPROVED',
        statusByHr: 'APPROVED',
      },
    });
    if (responseEntities.length) {
      for (const responseEntity of responseEntities) {
        const convertedReqNameDto: RequestDto = this.adapter.convertEntityToDto(
          responseEntity
        );
        getReqByName.push(convertedReqNameDto);
      }
      return new CommonResponse(
        true,
        1,
        'Request retrieved successfully',
        getReqByName
      );
    } else {
      return new CommonResponse(false, 11101, 'Request not found');
    }
  }

  async updateRequest(updateDto: RequestDto): Promise<GlobalResponseObject> {
    const updateReq = await this.requestRepo.findOne({
      where: { requestId: updateDto.requestId },
    });
    if (!updateReq) {
      throw new ErrorResponse(11839, 'No Request Id exists with given Input');
    } else {
      const updateReqSave = await this.requestRepo.update(
        { requestId: updateDto.requestId },
        {
          visitorName: updateDto.visitorName,
          visitorCard: updateDto.visitorCard,
          visitorEmail: updateDto.visitorEmail,
          visitorMobileNumber: updateDto.visitorMobileNumber,
          aadharNumber: updateDto.aadharNumber,
          transportation: updateDto.transportation,
          vehicleNumber: updateDto.vehicleNumber,
          driverName: updateDto.driverName,
        }
      );
      return new GlobalResponseObject(true, 98898, 'Successfully updated');
    }
  }

  //     async updateRequest(updateDto: RequestDto): Promise<GlobalResponseObject> {
  //         const updateReq = await this.requestRepo.findOne({ where: { requestId: updateDto.requestId } })
  //         if(updateReq) {
  //             const updateReqSave = await this.requestRepo.update({requestId: updateDto.requestId}, {
  // );
  //             return new GlobalResponseObject(true, 98898, "Updated Successfully");
  //         } else {
  //             return new GlobalResponseObject(false, 99998, "RequestId not found")
  //         }
  //     }

  // async updateRequest(updateDto: RequestDto): Promise<GlobalResponseObject> {
  //     const updateReq = await this.requestRepo.findOne({ where: { requestId: updateDto.requestId } })
  //     if(updateReq) {
  //         const updateReqEntity = this.adapter.convertDtoToEntity(updateDto);
  //         const updateReqSave = await this.requestRepo.save(updateReqEntity);
  //         return new GlobalResponseObject(true, 98898, "Updated Successfully");
  //     } else {
  //         return new GlobalResponseObject(false, 99998, "RequestId not found")
  //     }
  // }

  async getReport(requestReport: RequestReport): Promise<CommonResponse> {
    const getReqReportDto: VisitorDto[] = [];
    // const fromdate = moment(requestReport.fromDate).format("YYYY-MM-DD");
    // const todate = moment(requestReport.toDate).format("YYYY-MM-DD");
    const responseEntities = await this.visitorRepo.find({
      order: { id: 'ASC' },
      where: {
        checkIn: Between(requestReport.fromDate, requestReport.toDate),
        checkOut: Between(requestReport.fromDate, requestReport.toDate),
      },
    });
    console.log(responseEntities, '****');
    if (responseEntities.length) {
      responseEntities.forEach((Entity) => {
        const convertedReqEntity: VisitorDto = this.visitorAdapter.convertVisitorEntityToDto(
          Entity
        );
        console.log(convertedReqEntity, '&&&&');
        getReqReportDto.push(convertedReqEntity);
      });
      return new CommonResponse(
        true,
        98898,
        'Requests retrieved successfully',
        getReqReportDto
      );
    } else {
      return new CommonResponse(false, 11101, 'No data found');
    }
  }

  async getByDate(requestReport: RequestReport): Promise<CommonResponse> {
    console.log(requestReport,"report")
    const getReqReportDto: RequestDto[] = [];
    // const fromdate = moment(requestReport.fromDate).format("YYYY-MM-DD");
    // const todate = moment(requestReport.toDate).format("YYYY-MM-DD");
    const responseEntities = await this.requestRepo.find({
      order: { requestId: 'ASC' },
      where: {
        visitorArrivalDate:Between(requestReport.fromDate, requestReport.toDate),
        visitorDepartureDate:Between(requestReport.fromDate, requestReport.toDate),
      },
    });
    console.log(responseEntities, '****');
    if (responseEntities.length) {
      responseEntities.forEach((Entity) => {
        const convertedReqEntity: RequestDto = this.adapter.convertEntityToDto(
          Entity
        );
        console.log(convertedReqEntity, '&&&&');
        getReqReportDto.push(convertedReqEntity);
      });
      return new CommonResponse(
        true,
        98898,
        'Requests retrieved successfully',
        getReqReportDto
      );
    } else {
      return new CommonResponse(false, 11101, 'No data found');
    }
  }

  async validateCheckInDate(req: any) {
    const visotrDates = await this.requestRepo.findOne({
      select: ['visitorArrivalDate', 'visitorDepartureDate'],
      where: { requestId: req.requestId },
    });
    console.log(visotrDates, 'visotrdates');
    const checkDate = moment(moment()).isBetween(
      moment(visotrDates.visitorArrivalDate).format('YYYY-MM-DD'),
      moment(visotrDates.visitorDepartureDate).format('YYYY-MM-DD')
    ); 

    let checkDate1 = false;
    
    if(moment(visotrDates.visitorArrivalDate).format('YYYY-MM-DD') === moment(Date.now()).format('YYYY-MM-DD') && moment(visotrDates.visitorDepartureDate).format('YYYY-MM-DD') === moment(Date.now()).format('YYYY-MM-DD')) {
      checkDate1 = true;
    }
    console.log(moment(visotrDates.visitorArrivalDate).format('YYYY-MM-DD'),moment(visotrDates.visitorDepartureDate).format('YYYY-MM-DD'),'***')
    console.log(checkDate, 'checkdate');
    if (checkDate || checkDate1) return new CommonResponse(true, 1111, 'validated');
    return new CommonResponse(
      false,
      1110,
      'This visitor have no permission on this date'
    );
  }

  async createCheckIn(createDto: VisitorDto): Promise<GlobalResponseObject> {
    const req = { requestId: createDto.requestId };
    const validateDate = await this.validateCheckInDate(req);
    if (!validateDate.status) return validateDate;
    const visitorEntity = this.visitorAdapter.convertVisitorDtoToEntity(
      createDto
    );
    const visitorSave = await this.visitorRepo.save(visitorEntity);
    return new GlobalResponseObject(true, 98898, 'Successfully Created');
  }

  async updateCheckOut(updateDto: VisitorDto): Promise<GlobalResponseObject> {
    const updateCheck = await this.visitorRepo.findOne({
      where: { id: updateDto.id },
    });
    if (!updateCheck) {
      throw new ErrorResponse(11839, 'No id exists with given Input');
    } else {
      const updateCheckSave = await this.visitorRepo.update(
        { id: updateDto.id },
        {
          checkOut: moment(Date.now()).format('YYYY-MM-DD'),
        }
      );
      return new GlobalResponseObject(true, 98898, 'Successfully updated');
    }
  }

  async getAllCheckIn(req: RequestById): Promise<CommonResponse> {
    const getCheckDto: VisitorDto[] = [];
    let getCheckEntities: VisitorEntry[] = [];
    getCheckEntities = await this.visitorRepo.find({order: { id: 'ASC' },where: { checkOut: null },});
    if(req.requestId != 0) {
      getCheckEntities = await this.visitorRepo.find({order: { id: 'ASC' },where: { checkOut: null, requestId: req.requestId },});

    }
    if (getCheckEntities.length) {
      for (const getCheckEntity of getCheckEntities) {
        const convertedCheckDto: VisitorDto = this.visitorAdapter.convertVisitorEntityToDto(
          getCheckEntity
        );
        getCheckDto.push(convertedCheckDto);
      }
      const response = new CommonResponse(
        true,
        1,
        "Check-In's retrieved successfully",
        getCheckDto
      );
      return response;
    } else {
      throw new CommonResponse(false, 99998, 'Data not found');
    }
  }

  async getAllCheckInReport(): Promise<CommonResponse> {
    const getCheckDto: VisitorDto[] = [];
    const getCheckEntities: VisitorEntry[] = await this.visitorRepo.find({order: { id: 'ASC' } });
    // if (getCheckEntities.length) {
    //   for (const getCheckEntity of getCheckEntities) {
    //     const convertedCheckDto: VisitorDto = this.visitorAdapter.convertVisitorEntityToDto(
    //       getCheckEntity
    //     );
    //     getCheckDto.push(convertedCheckDto);
    //   }
    if(getCheckEntities){
      const response = new CommonResponse( true, 1, "Check-In's retrieved successfully",getCheckEntities);
      return response;
    } else {
      throw new CommonResponse(false, 99998, 'Data not found');
    }
  }

  async getReqIdPreviewData(req: RequestById): Promise<CommonResponse> {
    const getReqIdPreviewDto: RequestDto[] = [];
    const responseEntity = await this.requestRepo.findOne({
      where: { requestId: req.requestId },
    });
    if (responseEntity) {
      const convertedReqIdDto: RequestDto = this.adapter.convertEntityToDto(
        responseEntity
      );
      const history  = await this.requestRepo.historyData(convertedReqIdDto);
      getReqIdPreviewDto.push(convertedReqIdDto);
      
      getReqIdPreviewDto[0].pastTransactios = history;
      return new CommonResponse(
        true,
        1,
        'Request previewed successfully',
        getReqIdPreviewDto
      );
    } else {
      return new CommonResponse(false, 11101, 'RequisitiontId not found');
    }
  }

  async getExpiredRequests(): Promise<CommonResponse> {
    const getExpReqDto: RequestDto[] = [];
    const responseEntities = await this.requestRepo.find({
      where: {
        visitorDepartureDate: LessThan(moment(new Date()).format('YYYY-MM-DD')),
        statusByHod: 'Open',
      },
    });
    console.log(responseEntities, '****');
    if (responseEntities.length) {
      responseEntities.forEach((Entity) => {
        const convertedReqEntity: RequestDto = this.adapter.convertEntityToDto(
          Entity
        );
        console.log(convertedReqEntity, '&&&&');
        getExpReqDto.push(convertedReqEntity);
      });
      return new CommonResponse(
        true,
        98898,
        'Requests retrieved successfully',
        getExpReqDto
      );
    } else {
      return new CommonResponse(false, 11101, 'No data found');
    }
  }

  async getExpiredRequestsHr(): Promise<CommonResponse> {
    const getExpReqDto: RequestDto[] = [];
    const responseEntities = await this.requestRepo.find({
      where: {
        visitorDepartureDate: LessThan(moment(new Date()).format('YYYY-MM-DD')),
        statusByHod: 'APPROVED',
      },
    });
    console.log(responseEntities, '****');
    if (responseEntities.length) {
      responseEntities.forEach((Entity) => {
        const convertedReqEntity: RequestDto = this.adapter.convertEntityToDto(
          Entity
        );
        console.log(convertedReqEntity, '&&&&');
        getExpReqDto.push(convertedReqEntity);
      });
      return new CommonResponse(
        true,
        98898,
        'Requests retrieved successfully',
        getExpReqDto
      );
    } else {
      return new CommonResponse(false, 11101, 'No data found');
    }
  }
  
  async searchByName(req:RequestByName): Promise<CommonResponse> {
    console.log(req,"req")
    const getByName: VisitorDto[] =[];
    const responseEntities = await this.visitorRepo.find({where:{visitorName: req.visitorName}})
    if(responseEntities.length) {
      responseEntities.forEach((Entity)=> {
        const convertedReqEntity: VisitorDto = this.visitorAdapter.convertVisitorEntityToDto(Entity);
        getByName.push(convertedReqEntity);
      })
      return new CommonResponse(true, 988898, 'Request retrieved successfully',getByName)
    } else {
      return new CommonResponse(false,11101, 'No data found with this name!')
    }
  }

  async getDateReport(req: RequestReport): Promise<CommonResponse> {
    const getCheckDto: VisitorDto[] = [];
    const getCheckEntities: VisitorEntry[] =  await this.visitorRepo.find({order: { id: 'ASC' },where: { checkOut: null, checkIn: Between(req.fromDate, req.toDate) },});
    if (getCheckEntities.length) {
      for (const getCheckEntity of getCheckEntities) {
        const convertedCheckDto: VisitorDto = this.visitorAdapter.convertVisitorEntityToDto(
          getCheckEntity
        );
        getCheckDto.push(convertedCheckDto);
      }
      const response = new CommonResponse(
        true,
        1,
        "Data retrieved successfully",
        getCheckDto
      );
      return response;
    } else {
      throw new CommonResponse(false, 99998, 'Data not found');
    }
  }
  
  async visitorCount() : Promise<CommonResponse> {
    try{
      const manager = getManager()
      const query = `SELECT visit_type , COUNT(visitor_name) AS no_of_visitors FROM ` + appSettings.vms_db + `.requestform 
      GROUP BY visit_type ` 
      const dropData = await manager.query(query);
      if (dropData) {
        return new CommonResponse(true, 11608, "Visitors retrieved successfully", dropData)
      } else {
        return new CommonResponse(true, 11608, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }

  async todayVisitors() : Promise<CommonResponse> {
    try{
      const manager = getManager()
      const query = `SELECT COUNT(v.visitor_name) AS no_of_visitors,COUNT(v.check_in) AS check_in , 
      COUNT(v.check_out) AS check_out FROM ` + appSettings.vms_db + `.requestform rf 
      LEFT JOIN ` + appSettings.vms_db + `.visitorentry v ON rf.request_id = v.request_id 
      WHERE DATE(check_in) = 'DATE(NOW())' ` 

      const dropData = await manager.query(query);
      if (dropData) {
        return new CommonResponse(true, 11608, "Visitors retrieved successfully", dropData)
      } else {
        return new CommonResponse(true, 11608, "Something went wrong")
      }
    }
    catch (error) {
      return error
    }
  }
  
  async todayRequests() : Promise<CommonResponse>{
    try{
      const manager = getManager()
      const query = `SELECT COUNT(visitor_name) AS no_of_visitors FROM ` + appSettings.vms_db + `.requestform 
      WHERE DATE(created_at) = DATE(NOW()) `

      const dropData = await manager.query(query);
      if(dropData) {
        return new CommonResponse(true, 11608 , 'Request Retrived Successsfully',dropData)
      }else{
        return new CommonResponse(true,11608,'Something went wrong')
      }
    }
    catch(error){
      return error
    }
  }

  async hodCount() : Promise<CommonResponse>{
    try{
      const manager = getManager()
      const query = `SELECT COUNT(visitor_name) AS no_of_visitors , status_by_hod AS COUNT FROM  ` + appSettings.vms_db + `.requestform
      GROUP BY status_by_hod `
      const dropData = await manager.query(query);
      if(dropData) {
        return new CommonResponse(true, 11608 , 'HOD Count Retrived Successsfully',dropData)
      }else{
        return new CommonResponse(true,11608,'Something went wrong')
      }
    }
    catch(error){
      return error
    }
  }

  async hrCount() : Promise<CommonResponse>{
    try{
      const manager = getManager()
      const query = `SELECT COUNT(visitor_name) AS no_of_visitors , status_by_hr AS COUNT FROM  ` + appSettings.vms_db + `.requestform
      GROUP BY status_by_hr `
      const dropData = await manager.query(query);
      if(dropData) {
        return new CommonResponse(true, 11608 , 'HR Count Retrived Successsfully',dropData)
      }else{
        return new CommonResponse(true,11608,'Something went wrong')
      }
    }
    catch(error){
      return error
    }
  }

  async visitorMonthWiseCount() : Promise<CommonResponse>{
    try{
      const manager = getManager()
      const query = `SELECT SUM(IF(MONTH(check_in) = 1,1,0)) AS jan ,SUM(IF(MONTH(check_in) = 2,1,0)) AS feb,SUM(IF(MONTH(check_in) = 3,1,0)) AS mar,
      SUM(IF(MONTH(check_in) = 4,1,0)) AS apr , SUM(IF(MONTH(check_in) = 5,1,0)) AS may ,
      SUM(IF(MONTH(check_in) = 6,1,0)) AS jun , SUM(IF(MONTH(check_in) = 7,1,0)) AS july ,
      SUM(IF(MONTH(check_in) = 8,1,0)) AS aug , SUM(IF(MONTH(check_in) = 9,1,0)) AS sep,
      SUM(IF(MONTH(check_in) = 10,1,0)) AS octo , SUM(IF(MONTH(check_in) = 11,1,0)) AS nov ,
      SUM(IF(MONTH(check_in) = 12,1,0)) AS decm  FROM ` + appSettings.vms_db + `.visitorentry `
      const dropData = await manager.query(query);
      if(dropData) {
        return new CommonResponse(true, 11608 , 'Month Count Retrived Successsfully',dropData)
      }else{
        return new CommonResponse(true,11608,'Something went wrong')
      }
    }
    catch(error){
      return error
    }

  }

}
